import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../../services/login.service';
import { TenantData } from 'src/app/shared/components/sqp-components/sqpLogin/models/TenantData';
import { ModalMessageComponent } from 'src/app/shared/components/modals/modal-message/modal-message.component';

@Component({
  selector: 'app-login-azure-ad',
  templateUrl: './login-azure-ad.component.html',
  styleUrls: ['./login-azure-ad.component.css']
})
export class LoginAzureAdComponent implements OnInit {

  constructor(private route:ActivatedRoute,
              private snack:MatSnackBar,
              private dialog: MatDialog,
              private loginService:LoginService,
              private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
       params=>{
        if (params.error) {
          const dialogRef = this.dialog.open(ModalMessageComponent, {
            data: {
              mensaje: `Se ha producido un error: ${params.error}`,
              alert: true
            },
          });
          dialogRef.afterClosed().subscribe(() => {
            this.loginService.GetUrlLogin().subscribe({
              next: (url) => {
                if (url) {
                  window.location.href = url;
                } else {
                  this.snack.open('Se ha producido un error inesperado. No podemos acceder al login', 'Cerrar');
                }
              },
              error: (err) => {
                console.error(err);
                this.snack.open('Se ha producido un error inesperado. Contacte con su proveedor', 'Cerrar');
              },
            });
          });
          return;
        }

        if (!params.token) {
          return;
        }

        let tokenINfo = this.loginService.DecodeTokenLogin(params.token);

        let tenants:TenantData[] = JSON.parse(tokenINfo.Tenant);

        if(tenants.length==1){
            this.loginService.LoginAzureAd(tenants[0],params.token,tenants).subscribe(
              ok => {
                  this.router.navigate(["/panel/main"]);
              },
              error =>{
                // Mostrar mensaje de error
                console.error(error);
                let errorMsg = (error.status == 401) ? 'Usuario y/o contraseña no válidos' : error.message;

                this.snack.open(errorMsg, 'Cerrar', {duration: 3000});
              });
        }
        if(tenants.length>1){
          this.router.navigate([`selectTenant/${params.token}`]);
        }
      }
      );
  }

}
